module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_9005.8619eba5.png";